"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_2 = require("@emotion/react");
// Toastify
const react_toastify_1 = require("react-toastify");
require("react-toastify/dist/ReactToastify.css");
// Material UI
const styles_1 = require("@mui/material/styles");
const CssBaseline_1 = __importDefault(require("@mui/material/CssBaseline"));
// Theme
const theme_1 = require("../../../theme");
const ThemeProvider = (props) => {
    const { themeOverrides = {}, loadFonts = true } = props;
    return (react_1.default.createElement(styles_1.ThemeProvider, { theme: { ...theme_1.mui, ...themeOverrides } },
        react_1.default.createElement(react_2.Global, { styles: (0, react_2.css) `
          ${loadFonts ? `
            /* Import Lato font */
            @import url("https://fonts.googleapis.com/css2?family=Lato:wght@300;400;900&display=swap");
          ` : ""}
          
          .Toastify__toast {
            background: ${theme_1.colors.secondary[600]} !important;
            color: ${theme_1.colors.text[100]} !important;
          }

          .Toastify__close-button--light {
            color: ${theme_1.colors.text[100]} !important;
          }
        ` }),
        react_1.default.createElement(CssBaseline_1.default, null),
        react_1.default.createElement(react_toastify_1.ToastContainer, null),
        props.children));
};
exports.default = ThemeProvider;
